export enum webHostEnviroment {
  development = "development",
  test = "test",
  staging = "staging",
  production = "production",
}
